import { render, staticRenderFns } from "./AdminProductTemplatesScreen.vue?vue&type=template&id=126e7901&scoped=true&"
import script from "./AdminProductTemplatesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductTemplatesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e7901",
  null
  
)

export default component.exports